// extracted by mini-css-extract-plugin
export default {"titleBarContainer":"rightContainer_titleBarContainer__QRuOc","titleBar":"rightContainer_titleBar__ORtnx"};